import type { RouteObject } from 'react-router-dom'

import { Component } from '@/modules/dashboard/pages/Dashboard'
import { DashboardRoutePathsEnum } from '@/modules/dashboard/routes/dashboardRouteConfig.types'

export const DASHBOARD_ROUTES: RouteObject[] = [
  {
    element: <Component />,
    path: DashboardRoutePathsEnum.DASHBOARD,
  },
]
